<app-navbar></app-navbar>

<!-- Start Page Title Area -->
<div class="page-title-area bg-image" style="height: 250px;">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2 style="color: white;">Contact Us</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Contact Area -->
<section class="contact-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box">
                    <h3>Mailing Address</h3>
                    <a href="https://goo.gl/maps/PtciGwe5xpz3YbxS6" target="_blank">Jahangir Lane, <br>
                        Chattogram Cantonment, <br>
                        Chattogram <br>
                    </a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box">
                    <h3>Office Time</h3>
                    <p>Sunday to Thursday <br>
                        8.00am to 4.30pm</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box">
                    <h3>Contact</h3>
                    <a href="tel:+8801769243186">+8801769243186</a> <br>
                    <a href="mailto:proyashchattogram@gmail.com">proyashchattogram@gmail.com</a>
                </div>
            </div>
        </div>
    </div>

    <!-- <section style="padding: 50px 0 0 0; margin: 0;">
        <div class="googleMap">
            <div class="map-container">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1877783.7195172817!2d89.7995315!3d23.1867525!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30acd786438ed769%3A0xbdb2ec331bdfda77!2zUHJveWFzaCDgpqrgp43gprDgp5_gpr7gprg!5e0!3m2!1sen!2sbd!4v1693119906514!5m2!1sen!2sbd>"
                    width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
        </div>
    </section> -->

    <div class="row">
        <div class="col-lg-12 col-md-12">
            <div class="blog-details-desc"
                style="background-color: #FFFFFF; padding: 20px; border: 1px solid #eeeeee; margin-top: 30px;">
    
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1877783.7195172817!2d89.7995315!3d23.1867525!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30acd786438ed769%3A0xbdb2ec331bdfda77!2zUHJveWFzaCDgpqrgp43gprDgp5_gpr7gprg!5e0!3m2!1sen!2sbd!4v1693119906514!5m2!1sen!2sbd>"
                    width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    </div>
</section>
<!-- End Contact Area -->